

export function onReady(callback) {
  if (typeof window !== 'undefined' && window && window.sonicHelper && typeof window.sonicHelper.onReady === 'function') {
    window.sonicHelper.onReady(callback);
  } else {
    callback({ result: -103, message: 'sonicHelper no init' });
  }
}



// WEBPACK FOOTER //
// ../src/util/sonicHelper.js